module.exports = __webpack_public_path__ + "static/media/left_top_corner_triangle.3586528a.png";